import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";

import TeamChaseUp from "./TeamChaseUp.js";
import CertificationBlock from "../Assessment/certificationBlock.js";
import AreasOfSpecialization from "./AreasOfSpecialization.js";
import AboutUsCards from "./AboutUsCards.js";
import AboutChaseUp from "./AboutChaseUp.js";
import AboutUsHeader from "./AboutUsHeader.js";

const StyledAboutUs = styled(NanoFlex)`
  padding: 0 50px;
  gap: 124px;

  @media only screen and (max-width: 815px) {
    padding: 0px 30px 0px 30px;
    gap: 84px;
  }
`;

export default class AboutUs extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAboutUs flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} data-aos="fade-up" data-aos-duration="1500">
        <AboutUsHeader />
        <AboutChaseUp />
        <AboutUsCards />
        <AreasOfSpecialization />
        <TeamChaseUp />
        <CertificationBlock />
      </StyledAboutUs>
    );
  }
}
